// extracted by mini-css-extract-plugin
export default {"container":"PayboxModal_container__eQRoI","modal":"PayboxModal_modal__QA_G4","hidden":"PayboxModal_hidden__1sRGj"};